import { LayoutGray } from "@/components/LayoutGray";
import { MainButton } from "@/components/ui-components/MainButton";
import { buttonVariants } from "@/components/ui-components/MainButton/buttonVariants";

import styles from "./ErrorPageComponent.module.scss";

interface ErrorPageComponentProps {
  statusCode: number;
}

const ErrorPageComponent = ({ statusCode }: ErrorPageComponentProps) => {
  return (
    <LayoutGray isCartButton isProfileButton>
      <div className={styles.block}>
        <div className={styles.message}>
          {statusCode
            ? `An error ${statusCode} occurred on server`
            : "An error occurred on client"}
        </div>

        <MainButton
          href="/"
          variant={buttonVariants.BRIGHTWHITE}
          className={styles.button}
        >
          На главную
        </MainButton>
      </div>
    </LayoutGray>
  );
};

export default ErrorPageComponent;
